<template>
  <div class="question text_left">
    <title-bar-back :title="'客户服务'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div class="call_service font12 font_weight400 line_height_17 text_center">
      <div class="ser_item border_r" @click="goCustomer">
        <img src="@/assets/mine/inform/icon_service@2x.png" alt="" />
        <div>在线客服</div>
        <div class="item_call">（08:30-21:00）</div>
      </div>
      <div v-if="$appSource === 3" class="ser_item">
        <img src="@/assets/mine/inform/icon_call@2x.png" alt="" />
        <div>客服邮箱</div>
        <div class="item_call">
          <a href="mailto:app@mycodecrest.com">app@mycodecrest.com</a>
        </div>
      </div>
      <div v-else class="ser_item">
        <img src="@/assets/mine/inform/icon_call@2x.png" alt="" />
        <div>客服热线</div>
        <div class="item_call">
          <a href="tel:0571-86685812">0571-86685812</a>
        </div>
      </div>
    </div>
    <div class="que_card">
      <div class="que_title">
        <span class="title_line"></span>
        <span class="title_text">问题分类</span>
      </div>
      <div
        v-for="(item, index) in infoList"
        :key="index"
        class="list_sub"
        @click="goInfoDet(item)"
      >
        <span>{{ item.title }}</span>
        <img
          src="@/assets/common/icon_back_b87_24@2x.png"
          alt=""
          class="go_img"
        />
      </div>
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
export default {
  name: "QuestionList",
  components: {
    TitleBarBack
  },
  data() {
    return {
      infoList: [
        {
          title: "发票说明",
          url: "/mine/question/detail?key=14&name=发票说明"
        },
        {
          title: "海外直供",
          url: "/mine/question/detail?key=1&name=海外直供"
        },
        {
          title: "正品保障",
          url: "/mine/question/detail?key=2&name=正品保障"
        },
        {
          title: "购买流程",
          url: "/mine/question/detail?key=3&name=购买流程"
        },
        {
          title: "常见问题",
          url: "/mine/question/detail?key=4&name=常见问题"
        },
        {
          title: "破损包赔",
          url: "/mine/question/detail?key=6&name=破损包赔"
        },
        {
          title: "退货须知",
          url: "/mine/question/detail?key=7&name=退货须知"
        },
        {
          title: "退款说明",
          url: "/mine/question/detail?key=8&name=退款说明"
        },
        {
          title: "配送方式",
          url: "/mine/question/detail?key=10&name=配送方式"
        },
        {
          title: "物流追踪",
          url: "/mine/question/detail?key=11&name=物流追踪"
        },
        {
          title: "关于平台",
          url: "/mine/question/detail?key=12&name=关于平台"
        },
        {
          title: "告消费者书",
          url: "/mine/question/detail?key=13&name=告消费者书"
        }
      ]
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
    goCustomer() {
      this.$router.push("/customer");
    },
    goInfoDet(sub) {
      this.$router.push(sub.url);
    }
  }
};
</script>

<style scoped>
a:link {
  text-decoration: none;
  color: #bf9264;
}
a:visited {
  text-decoration: none;
  color: #bf9264;
}
a:hover {
  text-decoration: none;
  color: #bf9264;
}
a:active {
  text-decoration: none;
  color: #bf9264;
}
.title_right {
  width: 36px;
}
.call_service {
  display: flex;
  background: #fff;
  box-shadow: 0px 3px 6px -3px rgba(193, 200, 207, 0.5);
}
.ser_item {
  padding: 15px 0;
  flex: 1;
  color: #bf9264;
}
.ser_item img {
  width: 38px;
  height: 38px;
}
.item_call {
  margin-top: 8px;
}
.border_r {
  border-right: 1px solid rgba(0, 0, 0, 0.06);
}
.que_card {
  margin: 12px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 3px 6px -3px rgba(193, 200, 207, 0.5);
  overflow: hidden;
}
.que_title {
  height: 44px;
  display: flex;
  align-items: center;
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.06); */
}
.title_line {
  width: 2px;
  height: 14px;
  background-color: #bf9264;
  border-radius: 1px;
}
.title_text {
  font-size: 14px;
  color: rgba(34, 34, 34, 0.87);
  font-weight: 500;
  margin-left: 12px;
}
.list_sub {
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 48px;
  padding: 0 12px;
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.06); */
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}
.list_sub:last-child {
  border-bottom: none;
}
.go_img {
  width: 18px;
  height: 18px;
}
</style>
